<template>
    <div class="panel-wrapper">
        <i v-show="pointer.id === 0"></i>
        <div :class='ing?`head ing`:`head`' :style='`left:${pointer.pos.x};top:${pointer.pos.y}`'>
            <em></em>
            <span class="border1" v-if="pointer.type === 1" v-show="ing === false"></span>
            <span class="border2" v-else v-show="ing === false"></span>
        </div>
    </div>
</template>

<script>
import pointers from './const'
export default {
    name: 'Panel',
    props: {
        current: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            index: this.current,
            ing: false
        }
    },
    computed: {
        pointer() {
            let res = 0;
            if (this.index > 0) {
                if (this.index % 25 === 0) {
                    res = 25;
                } else {
                    res = this.index % 25;
                }
            }
            return pointers[res];
        }
    },
    methods: {
        runPointer(step) {
            return new Promise(resolve => {
                if (!this.ing) {
                    this.ing = true;
                    for (let i = 0; i < step; i++) {
                        setTimeout(() => {
                            this.index += 1;
                        }, i * 500)
                    }
                    setTimeout(() => {
                        setTimeout(() => {
                            this.ing = false;
                            resolve();
                        }, 1200)
                    }, step * 500)
                }
            })
        }
    },
    mounted(){
        this.$watch('current',function(){
            this.index = this.current;
        })
    }
}
</script>
<style lang="scss" scoped>
.icon {
    background-image: url('https://static.web.sdo.com/xuezu/pic/20221201_Game/icon.png');
    background-repeat: no-repeat;
    background-size: 20rem 20rem;
}

.panel-wrapper {
    background-image: url('https://static.web.sdo.com/xuezu/pic/20221201_Game/board.png');
    width: 6.92rem;
    height: 8.52rem;
    background-size: cover;
    left: 0.37rem;
    position: absolute;
    top: 2.36rem;
    pointer-events: none;
    z-index: 0;

    i {
        position: absolute;
        @extend .icon;
        width: 1.14rem;
        height: 0.46rem;
        background-position: -9.57rem -0.58rem;
        bottom: 0rem;
        right: 0.2rem;
    }

    .head {
        position: absolute;
        width: 1.17rem;
        height: 1.14rem;
        top: 6.97rem;
        left: 5.53rem;
        &.ing{
            transition: 0.2s;
        }
        em {
            width: 0.60rem;
            height: 0.74rem;
            @extend .icon;
            position: absolute;
            left: 50%;
            z-index: 1;
            top: 0.06rem;
            margin-left: -0.30rem;
            background-position: -16.44rem -4.35rem;
        }

        span {
            position: absolute;
            z-index: 0;
            @extend .icon;
            left: 50%;
            animation-name: fadeIn;
            animation-duration: 0.3s;
            animation-fill-mode: both;
            animation-iteration-count: 2;

            &.border1 {
                width: 0.84rem;
                height: 1.09rem;
                margin-left: -0.42rem;
                background-position: -15.85rem -7.73rem;
            }

            &.border2 {
                width: 100%;
                height: 100%;
                margin-left: -0.59rem;
                background-position: -17.23rem -7.73rem;
            }
        }
    }
}
</style>